export default __webpack_public_path__ + "static/media/menu.c4da44b0.svg";